// extracted by css-extract-rspack-plugin
export default {"pickerContainer":"MDx99","dimensionList":"ewZuM","itemWrapper":"sC4zN"};